// Aba Cardápio — o conteudo original da pagina de Banners (uploader + lista).

import BannerCard from "./components/BannerCard";
import BannersCarregando from "./components/BannersCarregando";
import BannersEmptyState from "./components/BannersEmptyState";
import BannerUploader from "./components/BannerUploader";
import { useBanners } from "./hooks/useBanners";

export default function CardapioBannersTab() {
  const {
    banners, loading, enviando, maximo,
    adicionar, alternarAtivo, remover, mover,
  } = useBanners("cardapio");

  const noAr = banners.filter((b) => b.enabled).length;

  return (
    <div className="space-y-6">
      <p className="text-xs text-muted-foreground -mt-2">
        {banners.length === 0
          ? `Até ${maximo} banners.`
          : `${noAr} no ar de ${banners.length} cadastrado${banners.length === 1 ? "" : "s"} · máximo ${maximo}`}
      </p>

      <BannerUploader
        onArquivo={adicionar}
        enviando={enviando}
        desabilitado={banners.length >= maximo}
        aceitaVideo
      />

      {loading ? (
        <BannersCarregando />
      ) : banners.length === 0 ? (
        <BannersEmptyState />
      ) : (
        <div className="space-y-3">
          {noAr > 1 && (
            <p className="text-xs text-muted-foreground">
              Com mais de um banner no ar, o cardápio mostra um carrossel nesta ordem.
            </p>
          )}
          {banners.map((banner, i) => (
            <BannerCard
              key={banner.id}
              banner={banner}
              posicao={i}
              total={banners.length}
              onToggle={alternarAtivo}
              onRemover={remover}
              onMover={mover}
            />
          ))}
        </div>
      )}
    </div>
  );
}
